import { useGetPremiumPays } from 'queries';
import { isNil } from 'ramda';

import { PremiumPay, PremiumPayFlagsEnum } from '../../../types';

import { isFlagContained } from '../utils/utils';

export interface PremiumPaysTableData extends PremiumPay {
  hasDayMonday: boolean;
  hasDayTuesday: boolean;
  hasDayWednesday: boolean;
  hasDayThursday: boolean;
  hasDayFriday: boolean;
  hasDaySaturday: boolean;
  hasDaySunday: boolean;
  hasDayHoliday: boolean;
  hasDayHolidaySat: boolean;
  hasDayHolidaySun: boolean;
  hasDaySpecial: boolean;
  hasTimeFromTHR: boolean;
  hasTimeToTHR: boolean;
  validFrom: string;
  validTo: string;
}

const useGetPremiumPaysTableData = (): PremiumPaysTableData[] | undefined => {
  const { data } = useGetPremiumPays();

  if (isNil(data)) {
    return data;
  }

  return data.map((premiumPay) => ({
    ...premiumPay,
    hasDayMonday: isFlagContained(
      premiumPay.flags,
      PremiumPayFlagsEnum.DAY_MONDAY
    ),
    hasDayTuesday: isFlagContained(
      premiumPay.flags,
      PremiumPayFlagsEnum.DAY_TUESDAY
    ),
    hasDayWednesday: isFlagContained(
      premiumPay.flags,
      PremiumPayFlagsEnum.DAY_WEDNESDAY
    ),
    hasDayThursday: isFlagContained(
      premiumPay.flags,
      PremiumPayFlagsEnum.DAY_THURSDAY
    ),
    hasDayFriday: isFlagContained(
      premiumPay.flags,
      PremiumPayFlagsEnum.DAY_FRIDAY
    ),
    hasDaySaturday: isFlagContained(
      premiumPay.flags,
      PremiumPayFlagsEnum.DAY_SATURDAY
    ),
    hasDaySunday: isFlagContained(
      premiumPay.flags,
      PremiumPayFlagsEnum.DAY_SUNDAY
    ),
    hasDayHoliday: isFlagContained(
      premiumPay.flags,
      PremiumPayFlagsEnum.DAY_HOLIDAY
    ),
    hasDayHolidaySat: isFlagContained(
      premiumPay.flags,
      PremiumPayFlagsEnum.DAY_HOLIDAY_SAT
    ),
    hasDayHolidaySun: isFlagContained(
      premiumPay.flags,
      PremiumPayFlagsEnum.DAY_HOLIDAY_SUN
    ),
    hasDaySpecial: isFlagContained(
      premiumPay.flags,
      PremiumPayFlagsEnum.DAY_SPECIAL
    ),
    hasTimeFromTHR: isFlagContained(
      premiumPay.flags,
      PremiumPayFlagsEnum.TIME_FROM_THR
    ),
    hasTimeToTHR: isFlagContained(
      premiumPay.flags,
      PremiumPayFlagsEnum.TIME_TO_THR
    ),
    validFrom: premiumPay.valid.from,
    validTo: premiumPay.valid.to
  }));
};

export default useGetPremiumPaysTableData;
